import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import {
  IAgenciesPaginationQuery,
  IAgenciesPaginationRequestPayload,
  IRepresentativesProfilePayload,
} from 'shared/interfaces/IRepresentatives';
import {
  IRepresentativesResumePayloadResponse,
  IRepresentativesSingleProfilePayload,
  IRrepresentativeShowHiddenMediaPayload,
  IRrepresentativeShowHiddenMediaPayloadResponse,
  ISingleRepresentativeAttachedMediaPayload,
  ISingleRepresentativeAttachedMediaPayloadResponse,
  ISingleRepresentativeHiddenAMediaPayload,
  ISingleRepresentativeHiddenMediaPayloadResponse,
} from 'shared/interfaces/IRepresentativesEditProfile';
import {
  AGENCIES_PAGINATION,
  MULTIPLE_REPRESENTATIVES_PROFILE,
  SINGLE_REPRESENTATIVE_ATTACHED_MEDIA,
  SINGLE_REPRESENTATIVE_HIDDEN_MEDIA,
  SINGLE_REPRESENTATIVE_PROFILE,
  SINGLE_REPRESENTATIVE_RESUMES,
} from 'shared/queries/representatives.queries';
import { authToken } from 'shared/utils/authToken';

const { POST } = useAxios();

export const representativesDao = () => {
  const { getAuthToken } = authToken();

  // Getting all representatives profile of talent
  const getMultipleRepresentativesProfile = async () => {
    const response = await POST<IRepresentativesProfilePayload>({
      url: `${ENDPOINTS.GRAPHQL}`,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      data: {
        query: MULTIPLE_REPRESENTATIVES_PROFILE,
      },
    });

    return response?.data;
  };

  const getSingleRepresentativeProfile = async (id: string) => {
    const response = await POST<IRepresentativesSingleProfilePayload>({
      url: ENDPOINTS.GRAPHQL,
      data: {
        query: SINGLE_REPRESENTATIVE_PROFILE,
        variables: { id },
      },
    });

    return response.data;
  };

  const getAgenciesWithPagination = async ({ country, search, first = 5, after }: IAgenciesPaginationQuery) => {
    const response = await POST<IAgenciesPaginationRequestPayload>({
      url: `${ENDPOINTS.GRAPHQL}`,
      data: {
        query: AGENCIES_PAGINATION,
        variables: {
          first,
          search,
          country,
          after,
        },
      },
    });
    return response?.data;
  };

  const getSingleRepresentativeAttachedMediaGQL = async (payload: ISingleRepresentativeAttachedMediaPayload) => {
    const response = await POST<ISingleRepresentativeAttachedMediaPayloadResponse>({
      url: ENDPOINTS.GRAPHQL,
      data: {
        query: SINGLE_REPRESENTATIVE_ATTACHED_MEDIA,
        variables: payload,
      },
    });

    return response.data;
  };

  const getSingleRepresentativeHiddenMediaGQL = async (payload: ISingleRepresentativeHiddenAMediaPayload) => {
    const response = await POST<ISingleRepresentativeHiddenMediaPayloadResponse>({
      url: ENDPOINTS.GRAPHQL,
      data: {
        query: SINGLE_REPRESENTATIVE_HIDDEN_MEDIA,
        variables: payload,
      },
    });

    return response.data;
  };

  const postRepresentativeShowHiddenMedia = async (
    profileId: string,
    payload: IRrepresentativeShowHiddenMediaPayload[],
    signal?: AbortSignal,
  ) => {
    const response = await POST<IRrepresentativeShowHiddenMediaPayloadResponse>({
      url: `${ENDPOINTS.PROFILE}/${profileId}/medium_attachments`,
      data: { media: payload },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response.data;
  };

  const getRepresentativesResume = async (profileId: string) => {
    const response = await POST<IRepresentativesResumePayloadResponse>({
      url: `${ENDPOINTS.GRAPHQL}`,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      data: {
        query: SINGLE_REPRESENTATIVE_RESUMES,
        variables: { id: profileId },
      },
    });

    return response?.data;
  };

  return {
    getMultipleRepresentativesProfile,
    getAgenciesWithPagination,
    getSingleRepresentativeProfile,
    getSingleRepresentativeAttachedMediaGQL,
    getSingleRepresentativeHiddenMediaGQL,
    postRepresentativeShowHiddenMedia,
    getRepresentativesResume,
  };
};
